<template>
  <div id="app">
    <router-view ></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  components: {
    
  },
  mounted() {
  	
  }
}
</script>

<style>
	body {
		margin: 0!important;  
	}
#app {
 
}
</style>
